module.exports = __webpack_public_path__ + "img/pre-initiation_b.23a86d5c.png";